import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import WordlistModal from './WordlistModal';
import ModuleContext, { ModuleContextProvider } from '../material/_contexts/ModuleContext';

const StandaloneWordlistModal = () => {
  const { wordlistId } = useParams<{ wordlistId: string }>();
  const { module } = useContext(ModuleContext);

  if (!module || !wordlistId) return null;

  return (
    <div id="wordlist-modal" className="standalone-wordlist-container">
      <WordlistModal id={wordlistId} wordlistId={wordlistId} standalone module={module} />
    </div>
  );
};

export default function StandaloneWordlist() {
  useEffect(() => {
    window.loadingScreen?.finish();
  }, []);

  return (
    <ModuleContextProvider>
      <StandaloneWordlistModal />
    </ModuleContextProvider>
  );
}
